import "react";
export { M as default } from "../miniglobe-78788223.js";